module.exports = __webpack_public_path__ + "static/media/quindio-55.92e42bed.jpg";